/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * The DID method to use for the issuer DID.
 */
export type DraftLatestIssueRequestDidMethod = 'key' | 'web';
export const DraftLatestIssueRequestDidMethod = {
    Key: 'key',
    Web: 'web',
} as const;
